import { useHistory, useParams } from "react-router-dom";
import { useTerritoryManager } from "./hooks/useTerritoryManager";
import TerritoryManagerLoader from "./components/skeletons/EditTerritoryManagerSkeleton";
import ErrorPage from "../shared/components/BaseError";
import EntityPageLayout from "../shared/components/EntityPageLayout";
import { useIntl } from "react-intl";
import BaseButton from "components/common/BaseButton";
import useMutateTerritoryManager from "./hooks/useMutateTerritoryManager";
import { useState } from "react";
import DeletionModal from "../shared/components/DeletionModal";

const ViewTerritoryManagerPage = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEntityId, setSelectedEntityId] = useState<string | null>(null);
  const [entityName, setEntityName] = useState("");

  const history = useHistory();

  const intl = useIntl();

  const { entityId } = useParams<{
    entityId: string;
  }>();

  const {
    data: tm,
    isLoading,
    isError,
    error,
    refetch,
  } = useTerritoryManager({ territoryManagerId: entityId });

    const {
      deleteTerritoryManager,
      deleteTerritoryManagerLoading,
      deleteTerritoryManagerSuccess,
      deleteTerritoryManagerReset,
      deleteTerritoryManagerIsError,
    } = useMutateTerritoryManager({ id: selectedEntityId as string });
  
    const handleDelete = () => {
      const tmName = tm?.name || "";
      setSelectedEntityId(tm?.id.toString() || "");
      setShowDeleteModal(true);
      setEntityName(tmName);
    };

    const onEditClick = () => {
      history.push(`/us-admin-app/territory-managers/${entityId}/edit`);
    }
  
    const confirmDelete = () => {
      if (selectedEntityId) {
        deleteTerritoryManager({ territoryManagerId: selectedEntityId });
      }
    };

  if (isError)
    return (
      <EntityPageLayout headerMessage="usAdmin.viewTerritoryManager">
        <ErrorPage errorMessage={error} onRetry={refetch} />
      </EntityPageLayout>
    );

  if (isLoading)
    return (
      <EntityPageLayout headerMessage="usAdmin.viewTerritoryManager">
        <TerritoryManagerLoader />
      </EntityPageLayout>
    );

  return (
    <EntityPageLayout headerMessage="usAdmin.viewTerritoryManager">
      <div className="view-grid">
        <div className="view-container">
          <span className="view-container__title">{intl.formatMessage({ id: "usAdmin.name" })}</span>
          <span>{tm?.name || "N/A"}</span>
        </div>
        <div className="view-container">
          <span className="view-container__title">{intl.formatMessage({ id: "usAdmin.email" })}</span>
          <span>{tm?.email || "N/A"}</span>
        </div>
      </div>
      <div className="view-action-button-container">
        <BaseButton text={intl.formatMessage({ id: "usAdmin.edit" })} handleSubmit={onEditClick} />
        <BaseButton text={intl.formatMessage({ id: "usAdmin.delete" })} backgroundColor="red" handleSubmit={handleDelete} />
      </div>
      <DeletionModal
        isOpen={showDeleteModal || deleteTerritoryManagerSuccess || deleteTerritoryManagerIsError}
        isError={deleteTerritoryManagerIsError}
        isSuccess={deleteTerritoryManagerSuccess}
        loading={deleteTerritoryManagerLoading}
        deletedEntityName={entityName}
        onClose={() => {
          setShowDeleteModal(false);
          deleteTerritoryManagerReset();
        }}
        onConfirm={confirmDelete}
      />
    </EntityPageLayout>
  );
};

export default ViewTerritoryManagerPage;
